import Vue from 'vue'
import Vuex from 'vuex'
import { EquipmentType, CommonStyle, CommonClass } from '@/constants';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    //当前前面下标
    navIndex: 0,
    currentEquipment: EquipmentType.PC,
  },
  getters: {
    getCommonStyle(state) {
      return {
        style: CommonStyle[state.currentEquipment],
        class: CommonClass[state.currentEquipment],
      }
    }
  },
  mutations: {
    //设置当前页面下标
    setNavIndex(state,data) {
      state.navIndex = data;
    },
    setCurrentEquipment(state,data) {
      state.currentEquipment = data;
    }
  },
  actions: {
  },
  modules: {
  }
})
